import { handleActions } from 'redux-actions';
import { toggleFilter } from './actions';

const defaultState = {
  filters: {
    checked: [
      'showFromIsrael',
      'showFromGermany'
    ]
  }
};

export default handleActions({
  [toggleFilter]: (state, { payload: name }) => {
    const newState = JSON.parse(JSON.stringify(state));
    const checked = newState.filters.checked;
    const idx = checked.indexOf(name);

    if (idx === -1) {
      checked.push(name);
    } else {
      checked.splice(idx, 1);
    }

    newState.filters.checked = checked;

    return newState;
  }
},
defaultState);



// WEBPACK FOOTER //
// ./src/store/wishes/reducer.js